package dev.kuml.portal.web.editor

import dev.kuml.portal.web.i18n.strings.EditorStrings

/**
 * Translates a rejected [ClientModelOp]'s [ClientModelOpRejectReason] into user-facing status-line
 * copy (R-27, kUML Portal "Interactive Diagram-Editing UI" wave) -- per the design-team ruling
 * "abgelehnte Op = Statuszeile, Verbindung bleibt offen": a rejection is shown as a transient status
 * message, never a modal/toast that blocks further editing, and the WebSocket connection itself is
 * never closed over it (see `CollabRoutes.kt`'s server-side counterpart of this same rule).
 */
public object ModelOpFeedback {
    public fun messageFor(
        reason: ClientModelOpRejectReason,
        strings: EditorStrings,
    ): String =
        when (reason) {
            ClientModelOpRejectReason.MALFORMED -> strings.opRejectedMalformed
            ClientModelOpRejectReason.UNKNOWN_ELEMENT -> strings.opRejectedUnknownElement
            ClientModelOpRejectReason.LIMIT_EXCEEDED -> strings.opRejectedLimitExceeded
            ClientModelOpRejectReason.INVALID_VALUE -> strings.opRejectedInvalidValue
            ClientModelOpRejectReason.NO_LIVE_ROOM -> strings.opRejectedNoLiveRoom
        }
}
